// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCalendarDaily24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.75 4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4V5H9.75V4C9.75 3.58579 9.41421 3.25 9 3.25C8.58579 3.25 8.25 3.58579 8.25 4V5H6C4.34315 5 3 6.34315 3 8V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V8C21 6.34315 19.6569 5 18 5H15.75V4ZM8.25 8V6.5H6C5.17157 6.5 4.5 7.17157 4.5 8V10.25H19.5V8C19.5 7.17157 18.8284 6.5 18 6.5H15.75V8C15.75 8.41421 15.4142 8.75 15 8.75C14.5858 8.75 14.25 8.41421 14.25 8V6.5H9.75V8C9.75 8.41421 9.41421 8.75 9 8.75C8.58579 8.75 8.25 8.41421 8.25 8ZM19.5 11.75H4.5V18C4.5 18.8284 5.17157 19.5 6 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V11.75ZM9.5 13.75C9.5 14.1642 9.16421 14.5 8.75 14.5C8.33579 14.5 8 14.1642 8 13.75C8 13.3358 8.33579 13 8.75 13C9.16421 13 9.5 13.3358 9.5 13.75ZM11.75 14.5C12.1642 14.5 12.5 14.1642 12.5 13.75C12.5 13.3358 12.1642 13 11.75 13C11.3358 13 11 13.3358 11 13.75C11 14.1642 11.3358 14.5 11.75 14.5ZM15.5 13.75C15.5 14.1642 15.1642 14.5 14.75 14.5C14.3358 14.5 14 14.1642 14 13.75C14 13.3358 14.3358 13 14.75 13C15.1642 13 15.5 13.3358 15.5 13.75ZM14.75 17.5C15.1642 17.5 15.5 17.1642 15.5 16.75C15.5 16.3358 15.1642 16 14.75 16C14.3358 16 14 16.3358 14 16.75C14 17.1642 14.3358 17.5 14.75 17.5ZM9.5 16.75C9.5 17.1642 9.16421 17.5 8.75 17.5C8.33579 17.5 8 17.1642 8 16.75C8 16.3358 8.33579 16 8.75 16C9.16421 16 9.5 16.3358 9.5 16.75ZM11.75 17.5C12.1642 17.5 12.5 17.1642 12.5 16.75C12.5 16.3358 12.1642 16 11.75 16C11.3358 16 11 16.3358 11 16.75C11 17.1642 11.3358 17.5 11.75 17.5Z"
				/>
			</Svg>
		);
	}
);
SvgCalendarDaily24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCalendarDaily24;
